import { useProductDayTripPlanFormModelContext } from "../context";
import { QuestionDayTripPlanBase } from "./base/root";
import { QuestionDayTripPlanConnection } from "./connection/root";
import { QuestionDayTripPlanIsDayTrip } from "./day-trip/root";
import { QuestionDayTripPlanEmail } from "./email/root";
import { QuestionDayTripPlanAttributes } from "./plan-attributes/root";
import { QuestionDayTripPlanPreQuestions } from "./pre-questions/root";
import { QuestionDayTripPlanPriceAndPolicy } from "./price-and-policy/root";
import { QuestionDayTripPlanStayLength } from "./stay-length/root";
import { QuestionDayTripPlanStock } from "./stock/root";
import { QuestionDayTripPlanTerm } from "./term/root";

import type { DayTripPlanCategoriesAndManagerStore } from "../store/categories";

type Props = {
	dayTripPlanCategoriesAndManagerStore: Omit<
		DayTripPlanCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const DayTripPlanFormMain = ({ dayTripPlanCategoriesAndManagerStore }: Props) => {
	const { hotelID, planID, name } = useProductDayTripPlanFormModelContext().viewModel;

	const { base, connection, priceAndPolicy, email, preQuestions, term, stock, stayLength, planAttributes, dayTrip } =
		dayTripPlanCategoriesAndManagerStore;

	return (
		<>
			<QuestionDayTripPlanBase base={base} hotelID={hotelID} planID={planID} />
			<QuestionDayTripPlanIsDayTrip dayTrip={dayTrip} />
			<QuestionDayTripPlanConnection connection={connection} />
			<QuestionDayTripPlanPriceAndPolicy priceAndPolicy={priceAndPolicy} />
			<QuestionDayTripPlanTerm term={term} />
			<QuestionDayTripPlanStock stock={stock} />
			<QuestionDayTripPlanPreQuestions preQuestions={preQuestions} />
			<QuestionDayTripPlanEmail email={email} name={name.value} hotelID={hotelID} />
			<QuestionDayTripPlanAttributes planAttributes={planAttributes} />
			<QuestionDayTripPlanStayLength stayLength={stayLength} />
		</>
	);
};

DayTripPlanFormMain.displayName = "DayTripPlanFormMain";
